import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_91: FaireProductEntity = {
  token: "legacy_prod_abbott-91",
  type: "product",
  name: "Small Velvet Pouch with 3D Heart, Dark Grey 4×6 L",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/ba4a2659c1c09b1cccb767ac4a6b60c1ddaa8a3597dfd6ebf6ba8eb847c9d866.jpeg",
  priceDollars: 9,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_womens-accessories"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
